module.exports = __webpack_public_path__ + "media/images/btn_add_organization-86b54e5ed4ef50874481bcafad9a207b.gif";